import { render, staticRenderFns } from "./JumpingGameStart.vue?vue&type=template&id=3e1864f6&scoped=true&"
import script from "./JumpingGameStart.vue?vue&type=script&lang=js&"
export * from "./JumpingGameStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1864f6",
  null
  
)

export default component.exports